const SEARCH_PRODUCTS = "SEARCH_PRODUCTS";
const UPDATE_PRODUCTS = "UPDATE_PRODUCTS";
const SORT_PRODUCTS = "SORT_PRODUCTS";
const UPDATE_PRICE_RANGE = "UPDATE_PRICE_RANGE";
const SORT_BY_RATING = "SORT_BY_RATING";
const FILTER_BY_SECTION = "FILTER_BY_SECTION";
const FILTER_BY_CATEGORY = "FILTER_BY_CATEGORY";
const CLEAR_FILTERS = "CLEAR_FILTERS";
const SET_WISHLIST = "SET_WISHLIST";
const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
const SET_CART = "SET_CART";
const ADD_TO_CART = "ADD_TO_CART";
const REMOVE_FROM_CART = "REMOVE_FROM_CART";
const LOGIN = "LOGIN";
const LOGOUT = "LOGOUT";
export {
  SEARCH_PRODUCTS,
  UPDATE_PRODUCTS,
  SORT_PRODUCTS,
  UPDATE_PRICE_RANGE,
  SORT_BY_RATING,
  FILTER_BY_SECTION,
  FILTER_BY_CATEGORY,
  CLEAR_FILTERS,
  SET_WISHLIST,
  ADD_TO_WISHLIST,
  REMOVE_FROM_WISHLIST,
  SET_CART,
  ADD_TO_CART,
  REMOVE_FROM_CART,
  LOGIN,
  LOGOUT,
};
